<template>
  <div class="img-player-box" element-loading-text="正在初始化" element-loading-background="rgba(0, 0, 0, .3)">
    <div v-for="(item, index) in swiperArr" :key="index" class="swiperArr-name"
      :style="{ 'top': (index + 1) * imgH - 60 + 'px' }">
      <p>{{!swiperVisible ? item.name : swiperArr[swiperVisible - 1].name}}图像</p>
    </div>

    <div class="player-content" :style="{ cursor: bigImgReady ? 'crosshair' : 'auto' }">
      <swiper v-for="({ no, imgPath, name, swiperOptions }, index) in swiperArr" :key="no" :ref="`mySwiper${no}`"
        :options="swiperOptions" :style="{ height: imgH + 'px' }" v-show="!swiperVisible || swiperVisible === no">
        <swiper-slide v-for="(item, idx) in (isRight ? rightArr : slideList)" :key="item.id" :class="{
          'box-slide': true,
          'swiper-no-swiping': imgParams[item[imgPath].id] && imgParams[item[imgPath].id].zoomVal !== 1
        }">
          <div class="img-box" @wheel="imgZoom" @contextmenu="rightClick">
            <div class="carriage-info">
<!--              <div class="warning">-->
<!--                <div class="warning-light" :class="item[imgPath].isError ? 'warning-animation' : ''"></div>-->
<!--                <p>{{ name }}</p>-->
<!--              </div>-->
              <span>第{{ item.trainSerial }}节车厢</span>
              <span>{{ index === 1 ? item.containerNo1 : item.trainType }}</span>
              <span>{{ index === 1 ? item.containerNo2 : item.trainNo }}</span>
              <span v-if="index !== 1">速度: {{ item.trainSpeed }}km/h</span>
            </div>
            <img :id="item[imgPath].id" :data-index="!isRight ? idx : slideList.length - 1 - idx" :src="loadSrc" alt=""
              :style="{ filter: `brightness(${luminance[`swiper${no}`] / dfLuminance})` }" :data-swiperno="no"
              @error="e => { e.target.src = bakSrc }" @mousedown="imgMousedown" @mousemove.prevent.stop="imgMousemove"
              @mouseout="stopMove" @mouseup.prevent="stopMove" @mouseleave="stopMove" @dblclick="toHandleDoubleClick(no, item[imgPath].id, idx)" />
            <el-button v-show="false" v-has-permi="[`${permiStr}:early-warning`]" class="early-warning-btn" type="primary" @click="earlyWarning(item, imgPath)">
              预警
            </el-button>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!--  放大镜大图  -->
    <div v-show="bigImgUrl" v-loading="enlarging" element-loading-text="拼命放大中"
      element-loading-background="rgba(0, 0, 0, 0.8)" class="big-box">
      <i class="el-icon-circle-close" @click="bigImgUrl = ''"></i>
      <img ref="bigImg" :src="bigImgUrl" @load="enlarging = false" />
    </div>
    <!--  倍速  -->
    <div class="speed-box" v-show="speedTimes !== 1" :style="{ color: speedTimes > 1 ? 'red' : 'rgb(0, 255, 0)' }">
      X{{ speedTimes }}
    </div>
    <div class="player-footer" :style="{ width: swiperStyleWidth + '%', marginTop: '-4px', zoom, zIndex: reportVisible ? '' : 9999 }">
      <el-button @click="editPlay">
        {{ swiperPlay ? "暂 停" : "播 放" }}
      </el-button>
      <el-button @click="enlargeImg">放大镜</el-button>
      <el-button @click="deceleration">减 速</el-button>
      <el-button @click="accelerate">加 速</el-button>
      <el-button @click="slideTo(imgIdx() - 1)">上一节</el-button>
      <el-button @click="slideTo(imgIdx() + 1)">下一节</el-button>
      <el-button @click="resetImg">恢复</el-button>
      <el-button @click="openReport">检车报告</el-button>
      <el-button style="position: relative" @click="luminanceVisible = !luminanceVisible">
        亮度调节
        <luminance-adjust-dialog :visible="luminanceVisible" :luminance.sync="luminance"></luminance-adjust-dialog>
      </el-button>
      <el-button icon="el-icon-full-screen" @click="handleFullScreen"></el-button>
      <el-button v-has-permi="[`${permiStr}:carriage:add`]" @click="$emit('addCarriage')">车厢录入</el-button>
    </div>
    <early-warning ref="earlyWarning" @refreshEarlyWarning="refreshEarlyWarning"></early-warning>
  </div>

</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import LuminanceAdjustDialog from "../components/luminance-adjust-dialog.vue";
import earlyWarning from './early-warning.vue'
import _ from "lodash";
import {getSysConfig} from "@/util/util";

const baseSwiperOptions = {
  freeMode: true, // 自由模式
  freeModeMomentum: false, // 关闭惯性
  slidesPerView: 'auto', // 自动根据slides的宽度来设置slider容器能够同时显示的slides数量
  centeredSlides: true, // slide居中
}
export default {
  name: "img-player",

  components: {
    LuminanceAdjustDialog,
    Swiper,
    SwiperSlide,
    earlyWarning
  },
  props: {
    loading: Boolean,
    direction: String, // 方向
    slideList: Array,
    reportVisible: Boolean, // 检车报告 visible
    carriageIdx: [String, Number], // 当前车厢下标
    trainId: [String, Number], // 车次 id
    initialIdx: [String, Number], // 动画初始车厢下标
    permiStr: String,
    zoom: [String, Number],
  },
  data() {
    const that = this
    const swiperOn = {
      touchEnd: (e) => {
        that.showBigImg(e);
        if (that.swiperPlay) that.toEnd();
      },
      click: (e) => {
        e.preventDefault()
        // 只有点击图片元素时触发切换操作
        if (e.target.nodeName === 'IMG') {
          const idx = e.target.dataset.index
          that.slideTo(idx)
        }
      },
      doubleTap: (e) => {
        const swiperNo = e.target.dataset.swiperno
        that.handleDoubleClick(Number(swiperNo));
      }
    }
    return {
      bakSrc: require('./../img/error.png'),
      loadSrc: require('./../img/loading.png'),
      occupyW: 0,
      imgH: 0,
      isMounted: false,
      swiperPlay: false, // 是否播放
      baseSpeed: 0.05, // 播放速度
      speedTimes: 1, // 速度倍数
      swiperImgNum: 1, // 设置slider容器能够同时显示的slides数量
      swiperVisible: undefined, // 展示第几个 swiper，双击放大时使用
      swiperStyleWidth: 100, // swiper 宽度百分比，目前好像没用了，宽度固定 100%
      swiperArr: [
        {
          no: 1,
          imgPath: 'leftPath',
          name: '左侧',
          swiperOptions: {
            ...baseSwiperOptions,
            on: {
              ...swiperOn,
            },
          }
        },
        {
          no: 2,
          imgPath: 'topPath',
          name: '顶部',
          swiperOptions: {
            ...baseSwiperOptions,
            on: {
              ...swiperOn,
              touchStart: () => {
                that.customswiper3.controller.control = null;
                that.customswiper2.controller.control = [that.customswiper, that.customswiper3];
              }
            },
          }
        },
        {
          no: 3,
          imgPath: 'rightPath',
          name: '右侧',
          swiperOptions: {
            ...baseSwiperOptions,
            on: {
              ...swiperOn,
              touchStart: () => {
                that.customswiper2.controller.control = null;
                that.customswiper3.controller.control = [that.customswiper, that.customswiper2];
              }
            },
          },
        },
      ],
      bigImgReady: false, // 是否处在放大镜功能状态
      bigImgUrl: '', // 大图 url
      bigImgTimes: 5, // 放大镜放大倍数
      enlarging: false, // 放大中 loading
      luminanceVisible: false, // 亮度调节 visible
      luminance: {
        swiper1: 0,
        swiper2: 0,
        swiper3: 0
      },
      dfLuminance: 30,
      nowIdx: 0, // 当前展示 slide 下标
      step: 100, // 前进后退按钮控制像素
      medianLineOffset: 0, // 中位线上下偏移位置
      imgParams: {}, // 记录所有图片的位置，用于缩放、拖动
      baseImgParams: {
        zoomVal: 1,
        left: 0,
        top: 0,
        currentX: 0,
        currentY: 0,
        flag: false
      },
      timer: undefined,
      isRight: this.direction === 'right',
      alreadyLoad: [], // 已经加载的图片集和
    };
  },
  created() {
    const { dfLuminance } = this
    this.luminance = {
      swiper1: dfLuminance,
      swiper2: dfLuminance,
      swiper3: dfLuminance
    }
    this.setSwiperImgNum();
  },
  mounted() {
    this.isMounted = true;
    this.$emit('update:loading', true)
    setTimeout(() => {
      this.bindingControl();
      this.$emit('update:loading', false)
      // 取 slide 未开始移动时的偏移量(centeredSlides: true 自带偏移量)
      this.occupyW = this.currentSwiper.getTranslate()
      // 设置起始下标
      this.swiperPlay = true
      setTimeout(() => {
        this.slideTo(Number(this.initialIdx))
      }, 100)
      document.addEventListener("keyup", this.initKeyEvent, true)
      // 定时器
      this.timer = setInterval(() => {
        this.nowIdx = this.imgIdx()
      }, 1 * 1000)
    }, 3 * 1000)
    setTimeout(() => {
      this.initImgSrc(0)
    }, 100)

    // 监听窗口尺寸变化
    window.onresize = () => {
      // 全屏情况下不进行操作
      if (!document.fullscreenElement) {
        if (this.swiperVisible) this.handleDoubleClick(this.swiperVisible);
        this.setSwiperImgNum();
        if (this.swiperPlay) this.toEnd();
      }
    }
  },
  methods: {
    // --------------- 按钮点击方法 -----------------
    editPlay() {
      this.swiperPlay ? this.stop() : this.toEnd();
      this.swiperPlay = !this.swiperPlay;
    },
    // 放大镜
    enlargeImg() {
      if (!this.bigImgUrl) this.bigImgReady = true
    },
    // 加速
    accelerate() {
      if (this.speedTimes >= 1 && this.speedTimes < 5) {
        this.speedTimes = this.speedTimes + 1;
      } else if (this.speedTimes < 1) {
        this.speedTimes = this.numToFixed(this.speedTimes + 0.1, 1);
      }
    },
    // 减速
    deceleration() {
      if (this.speedTimes > 1) {
        this.speedTimes = this.speedTimes - 1;
      } else if (this.speedTimes <= 1 && this.speedTimes > 0.5) {
        this.speedTimes = this.numToFixed(this.speedTimes - 0.1, 1);
      }
    },
    // 恢复所有图片放大倍数及位置
    resetImg() {
      const keys = Object.keys(this.imgParams)
      keys.forEach(key => {
        const { img } = this.imgParams[key]
        img.style.transform = "scale(1)";
        img.style.left = "0px";
        img.style.top = "0px";
      })
      this.imgParams = {}
    },
    // 检车报告
    openReport() {
      this.$emit('update:reportVisible', true)
    },
    // 全屏
    handleFullScreen() {
      const { document } = window.parent;
      // 位移距离 / 图片宽度 取整 定义为当前 slide index
      // this.nowIdx = this.numToFixed(Math.abs(this.currentSwiper.getTranslate()) / Math.abs(this.imgWidth()), 0)
      // 如果处在双击放大状态，则取消放大状态
      if (this.swiperVisible) this.handleDoubleClick(this.swiperVisible)
      document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen();
      // 延迟调用, $nextTick 不行, timeout 0 也不行
      const nowIdx = this.nowIdx
      setTimeout(() => {
        this.setSwiperImgNum();
        this.slideTo(nowIdx)
      }, 100);

    },
    // 预警
    earlyWarning(info, imgPosition) {
      // 正在播放则停止播放
      if (this.swiperPlay) this.editPlay()
      this.$refs.earlyWarning.openEarlyWarning({ ...info, trainId: this.trainId }, imgPosition)
    },
    // ---------------------------- 鼠标事件 ------------------------------
    getImgParams(e) {
      const img = e.target;
      const imgParams = this.imgParams[img.id] || this.baseImgParams;
      const params = this.deepClone(imgParams)
      return { img, params }
    },
    rightClick(e) {
      const img = e.target;
      if (!img.id) return;
    },
    // 滑动滚轮缩放图片
    imgZoom(e) {
      const currentTarget =  !this.isNull(e.currentTarget) ? e.currentTarget : e.target
      const img = currentTarget.getElementsByTagName("img")[0];

      const imgParams = this.imgParams[img.id] || this.baseImgParams;
      let params = this.deepClone(imgParams)
      params.zoomVal += e.wheelDelta / 1200;
      if (params.zoomVal >= 1) {
        img.style.transform = `scale(${params.zoomVal})`;
      } else {
        // 初始化 params
        params = this.baseImgParams
        img.style.transform = "scale(1)";
        img.style.left = "0px";
        img.style.top = "0px";
      }
      params.img = img
      this.imgParams[img.id] = params
      this.$forceUpdate()
    },
    imgMousedown(e) {
      const { img, params } = this.getImgParams(e)
      params.flag = true
      params.currentX = e.clientX;
      params.currentY = e.clientY;
      this.imgParams[img.id] = params
    },
    imgMousemove(e) {
      const { img, params } = this.getImgParams(e)
      if (params.zoomVal === 1 || !params.flag) return
      const { left, top, currentX, currentY } = params
      let nowX = e.clientX, nowY = e.clientY;
      let disX = nowX - currentX, disY = nowY - currentY;
      img.style.left = left + disX + 'px';
      img.style.top = top + disY + 'px';
      this.$forceUpdate()
    },
    // 鼠标抬起或超出slide范围停止拖拽
    stopMove(e) {
      const { img, params } = this.getImgParams(e)
      if (params.zoomVal === 1 || !params.flag) return
      params.flag = false
      params.left = parseFloat(img.style.left)
      params.top = parseFloat(img.style.top)
      params.currentX = e.clientX;
      params.currentY = e.clientY;
      this.imgParams[img.id] = params
    },

    // ---------------------------- util ------------------------------

    // 当前 swiper slides 数量
    slideLength() {
      return this.currentSwiper.slides.length;
    },
    toEnd() {
      this.translateTo(this.swiperEnd(), this.swiperSpeed());
    },
    // 暂停swiper动画
    stop() {
      this.currentSwiper.setTranslate(this.currentSwiper.getTranslate());
    },
    // 绑定 control
    bindingControl() {
      this.customswiper.controller.control = [this.customswiper2, this.customswiper3];
    },
    // 移除 control
    removeControl() {
      this.customswiper.controller.control = this.customswiper2.controller.control = this.customswiper3.controller.control = null;
    },
    toHandleDoubleClick(no, id, idx) {
      if (this.imgParams[id] && this.imgParams[id].zoomVal !== 1) {
        this.handleDoubleClick(no, idx)
      }
    },
    // 双击
    handleDoubleClick(num, clickIndex) {
      // 与 this.currentSwiper 判断不同
      let customswiper = num === 1 ? this.customswiper : this[`customswiper${num}`];
      // 最后一次点击的 idx
      let idx = this.validatenull(clickIndex) ? customswiper.clickedIndex : clickIndex;
      if (this.isRight) idx = this.slideList.length - 1 - idx
      this.resetImg()
      if (this.swiperVisible) {
        // 还原，居中
        customswiper.params.centeredSlides = true
        this.swiperVisible = undefined;
        this.imgH = this.imgH / 3;
        // this.bindingControl();
        // 解决第一个 slide 切换不同步问题
        if (!idx) this.slideTo(1)
      } else {
        // 放大，不居中（解决首个和最后一个slide看不全问题）
        customswiper.params.centeredSlides = false
        // this.removeControl();
        this.swiperVisible = num;
        this.imgH = this.imgH * 3;
        this.$emit('closeSideDrawer')
      }
      this.$nextTick(() => {
        this.slideTo(idx);
      });
    },
    // 展示放大镜放大之后的图片
    showBigImg(e) {
      // 未点击放大镜按钮，点击图片不做放大操作
      if (!this.bigImgReady) return
      // 点击后关闭放大镜点击事件
      this.bigImgReady = false
      this.enlarging = true
      // 当前点击图片
      const img = e.target
      // 大图
      const bigImg = this.$refs.bigImg;
      // 当前点击图片宽高
      const baseW = img.offsetWidth, baseH = img.offsetHeight
      // 图片放大倍数
      let times = this.deepClone(this.bigImgTimes)
      // 处于双击放大状态时图片放大倍数
      if (this.swiperVisible) times = times / 3
      // 取值盒子宽高 (基于大图展示盒子宽高 .big-box) 此时元素隐藏宽高是 0 所以直接写死
      let w = 900 / times, h = 500 / times;
      // 大图尺寸
      bigImg.style.height = baseH * times + 'px'
      this.bigImgUrl = img.currentSrc;
      // 盒子左值及顶部位置
      let left = e.offsetX - w / 2;
      let top = e.offsetY - h / 2;
      // 判断方位超出的情况
      if (left < 0) {
        left = 0;
      } else if (left > baseW - w) {
        left = baseW - w;
      }
      if (top < 0) top = 0;
      else if (top > baseH - h) top = baseH - h;
      // 赋值定位（bigImg 是普通图的 times 倍大小 且方位为负值）
      bigImg.style.left = -times * left + "px";
      bigImg.style.top = -times * top + "px";
    },
    // 保留 n 位小数
    numToFixed(num, n = 2) {
      return Number(num.toFixed(n));
    },
    // -------------------------- 切换方法 ------------------------------

    /**
     *
     * @param translate 需要移动到的位置(单位像素)
     * @param speed 时间(单位毫秒)，默认 0
     */
    translateTo(translate, speed = 0) {
      this.currentSwiper.translateTo(translate, speed, true, true);
      // speed === 0 时认为是切换 slide 操作，此时如果为播放状态则需要继续播放到结束
      if (!speed && this.swiperPlay) {
        this.currentSwiper.translateTo(
          this.swiperEnd(),
          this.swiperSpeed(),
          true,
          true
        );
      }
    },
    /**
     *
     * @param idx 需要移动到的 silde 下标
     * @param swiper swiper
     * @param speed 动画时间
     */
    slideTo(idx, swiper = undefined, speed = 0) {
      // 动画加载时禁止切换车厢
      if (this.loading) return;
      // 播放状态无法切换到最后一个(不知道咋回事)，切换到最后一个之前先停下(到最后一个也没必要继续播放了)
      if (Number(idx) === this.slideLength() - 1 && this.swiperPlay) this.editPlay()
      this.$nextTick(() => {
        const customswiper = swiper ? swiper : this.currentSwiper;
        const targetIdx = !this.isRight ? idx : this.slideList.length - 1 - idx
        customswiper.slideTo(targetIdx, speed);
        this.initImgSrc(idx)
        setTimeout(() => {
          if (this.swiperPlay) this.toEnd();
        }, 0)
      });
    },

    // --------------------- 基础计算方法 ---------------------------

    // 计算 swiper高度
    setSwiperImgNum() {
      // 获取浏览器窗口文档显示区域的宽高
      const pageH = document.documentElement.clientHeight;
      // slide 高度, 60 是底部按钮区域高度
      this.imgH = this.numToFixed((pageH - 60) / 3);
    },
    // 一张图片宽度的距离
    imgWidth() {
      const width =
        !this.isRight
          ? -(this.currentSwiper.width / this.swiperImgNum)
          : this.currentSwiper.width / this.swiperImgNum;
      return this.numToFixed(width);
    },
    // 所有图片总宽度
    sumImgWidth() {
      let sumW = 0
      for (let i = 0; i < this.slideLength(); i++) {
        sumW += this.currentSwiper.slides[i].offsetWidth
      }
      return sumW
    },
    // 当前 slide 下标
    imgIdx() {
      let idx = 0
      let translate = Math.abs(this.currentSwiper.getTranslate()) + this.occupyW // 实时的wrapper位移 + occupyW占位，使图片在屏幕中间位置时下标就切换
      for (let i = 0; i < this.slideLength(); i++) {
        translate -= this.currentSwiper.slides[i].offsetWidth  // 移动距离减去当前 slides 宽度
        const num = this.numToFixed(Math.ceil(translate), 0) // 取整
        // 计算临界值，看情况取的（值越小动画移动时取值越靠前）
        let criticalValue = 30
        if (this.isRight) { // 发出方向（向右移动）
          // swiper translate > 0 的时候肯定是到最左侧了
          if (this.currentSwiper.getTranslate() > 0) {
            idx = 0
            break
          }
          // 一半图片宽 - 临界值（觉得下标切换慢可以多减点）（值越小动画移动时取值越靠前）
          criticalValue = this.currentSwiper.slides[i].offsetWidth / 2 - criticalValue
        }
        if (num < -criticalValue) {
          idx = i
          break
        } else if (num <= 0) {
          idx = i + 1
          break
        }
      }
      if (this.isRight) {
        // 'right' 时 swiper 最后一个是车厢第一个
        idx = this.slideList.length - 1 - idx
      }
      return idx
    },
    // 总共需要移动的距离
    sumTranslate() {
      const lastSlideWidth = this.currentSwiper.slides[this.slideLength() - 1].offsetWidth
      return this.sumImgWidth() - lastSlideWidth - this.occupyW
    },
    // 终点位置
    swiperEnd() {
      const lastSlideWidth = this.currentSwiper.slides[this.slideLength() - 1].offsetWidth
      // left 终点 = 总长 - 占位空 - 最后一张图片宽度
      const end = !this.isRight ? - (this.sumImgWidth() - this.occupyW - lastSlideWidth) : this.occupyW;
      // !this.isRight ? -this.sumImgWidth() : 0;
      return Math.ceil(end)
    },
    // 剩余所需移动的距离
    // 不使用计算属性，因为监听不到 this.customswiper.getTranslate() 变化
    swiperTranslate() {
      const translate =
        !this.isRight
          ? this.sumTranslate() + this.currentSwiper.getTranslate()
          : this.currentSwiper.getTranslate();
      return Math.abs(Math.ceil(translate));
    },
    // 剩余距离所需时间
    swiperSpeed() {
      const time = this.swiperTranslate() / (this.baseSpeed * this.speedTimes);
      return this.numToFixed(time);
    },
    // 键盘事件
    initKeyEvent(e) {
      // 存在弹窗时禁用按钮事件
      const dialog = document.getElementsByClassName('el-dialog__wrapper')
      if (dialog.length) return
      switch (e.key) {
        case 'ArrowLeft': {
          this.translateTo(this.currentSwiper.getTranslate() - this.step);
          break
        }
        case 'ArrowRight': {
          this.translateTo(this.currentSwiper.getTranslate() + this.step);
          break
        }
        case ' ': {
          this.editPlay()
          e.preventDefault();
          break
        }
      }
    },
    // 加载图片 src
    initImgSrc(idx) {
      const theIdx = Number(idx)
      const arr = this.slideList // 直接取 slideList 即可无需判断 isRight
      const keys = this.swiperArr.map(item => item.imgPath)
      const baseNum = 2 // 为当前下标前后 baseNum 个添加
      const minIdx = theIdx - baseNum < 0 ? 0 : theIdx - baseNum // 赋值开始
      const maxIdx = theIdx + baseNum > arr.length - 1 ? arr.length - 1 : theIdx + baseNum // 赋值结束
      const idxArr = _.range(minIdx, maxIdx + 1) // 需要赋值的所有下标集和
      idxArr.forEach(index => {
        keys.forEach(key => {
          const { id, src } = arr[index][key]
          if (!this.alreadyLoad.includes(id)) {
            const baseUrl = getSysConfig('CHECK_MINIO')
            this.getImageUrl(src.replace(baseUrl,''),'check').then(res => {
              document.getElementById(id).src = res // 直接替换图片 src
            })

            this.alreadyLoad.push(id) // 记录防止重复赋值
          }
        })
      })
    },
    //刷新预警车辆
    refreshEarlyWarning(){
      this.$emit('refreshEarlyWarning', this.nowIdx)
    }
  },
  computed: {
    customswiper() {
      return this.isMounted ? this.$refs.mySwiper1[0].$swiper : undefined
    },
    customswiper2() {
      return this.isMounted ? this.$refs.mySwiper2[0].$swiper : undefined
    },
    customswiper3() {
      return this.isMounted ? this.$refs.mySwiper3[0].$swiper : undefined
    },
    // 当前用作计算的 swiper
    currentSwiper() {
      const num = this.swiperVisible;
      return !num || num === 1 ? this.customswiper : this[`customswiper${num}`];
    },
    // direction "right" 时slide使用此数据
    rightArr() {
      let newArr = [];
      // 反转数组使车厢第一个到 swiper 最后一个
      for (let index = this.slideList.length - 1; index >= 0; index--) {
        newArr.push(this.slideList[index]);
      }
      return newArr
    }
  },
  watch: {
    speedTimes() {
      this.stop();
      if (this.swiperPlay) this.toEnd();
    },
    nowIdx(val) {
      if (val === this.carriageIdx) return
      this.$emit('update-idx', val)
      this.initImgSrc(val)
    },
  },
  beforeDestroy() {
    this.$emit('update-idx', 0)
    clearInterval(this.timer);
    this.timer = undefined;
    document.removeEventListener('keyup', this.initKeyEvent, true)
  }
}
</script>

<style lang="scss" scoped>
.img-player-box {
  width: 100%;
  height: 100%;

  .player-content {
    overflow: hidden;

    ::v-deep .swiper-slide {
      width: auto;
      /*根据内容调整宽度*/
    }

    .box-slide {
      overflow: hidden;

      .img-box {
        height: 100%;
        position: relative;
        box-sizing: border-box;

        .carriage-info {
          position: absolute;
          Z-index: 1;
          color: #77FF00;
          font-size: 26px;
          top: 11px;
          left: 30px;
          //width: 400px;
          //background-image: url('../img/title-bg.svg');
          // background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: left;
          padding-left: 25px;
          display: flex;
          align-items: center;
          padding-top: 3px;
          box-sizing: border-box;
          white-space: nowrap;
          padding-right: 15px;
          background-size: 100%;

          p {
            line-height: 36px;
            margin: 0;
          }

          span {
            margin: 0 5px;
            line-height: 18px;
          }

          .warning {
            display: flex;
            align-items: center;
            margin-right: 5px;

            .warning-light {
              margin-right: 10px;
              width: 22px;
              height: 22px;
              border-radius: 11px;
              background: #459AF9;
            }

            .warning-animation {
              background: #ff0000;
              animation: animation 1s infinite;
            }

            @keyframes animation {
              0% {
                transform: scale(1);
              }

              40% {
                transform: scale(0.6);
              }

              60% {
                transform: scale(0.6);
              }

              100% {
                transform: scale(1);
              }
            }
          }

          &__right {
            right: 30px;
            left: auto;
            transform: rotateY(180deg);

            span,p {
              transform: rotateY(180deg);
            }
          }
        }

        img {
          height: 100%;
          position: relative;
          left: 0;
          top: 0;

          &:hover {
            border: 2px solid rgb(255, 255, 0);
          }
        }

        .early-warning-btn {
          position: absolute;
          Z-index: 1;
          bottom: 5%;
          left: 50%;
          font-size: 18px;
          transform: translate(-30px, 0);
        }
      }

      .img-box:hover {
        .early-warning-btn {
          display: block !important;
        }
      }
    }

    ::v-deep .swiper-container {
      margin-right: 0;
    }
  }

  .big-box {
    width: 900px;
    height: 500px;
    position: absolute;
    top: 30%;
    left: 30%;
    border: 1px solid #aaaaaa;
    overflow: hidden;
    z-index: 2100;
    background: white;

    i {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 30px;
      color: #FFFFFF;
      cursor: pointer;
      z-index: 2100;
    }

    img {
      position: absolute;
    }

  }

  .speed-box {
    position: absolute;
    width: 30px;
    font-size: 30px;
    right: 430px;
    bottom: 100px;
    z-index: 1999;
    visibility: visible;
  }

  ::v-deep .player-footer {
    position: absolute;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: rgb(220, 220, 220);
    bottom: 0;

    .btn-arrow {
      padding: 10px 2px;
      margin: 0;
    }

    .el-button+.el-button {
      margin-left: 3px;
    }

    .el-button--mini {
      font-size: 17px;
      font-weight: bold;
    }
  }
}

/* 解决 swiper 速度不均问题 */
::v-deep .swiper-container-free-mode>.swiper-wrapper {
  -webkit-transition-timing-function: linear;
  /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}

.swiperArr-name {
  position: fixed;
  left: 50px;
  z-index: 99;

  p {
    font-size: 32px;
    font-weight: bold;
    color: #23a2cf;
    margin: 0;
  }
}
</style>
